import { render, staticRenderFns } from "./MedicalPlanBadges.vue?vue&type=template&id=3fd19eca&scoped=true"
import script from "./MedicalPlanBadges.vue?vue&type=script&lang=js"
export * from "./MedicalPlanBadges.vue?vue&type=script&lang=js"
import style0 from "./MedicalPlanBadges.vue?vue&type=style&index=0&id=3fd19eca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd19eca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fd19eca')) {
      api.createRecord('3fd19eca', component.options)
    } else {
      api.reload('3fd19eca', component.options)
    }
    module.hot.accept("./MedicalPlanBadges.vue?vue&type=template&id=3fd19eca&scoped=true", function () {
      api.rerender('3fd19eca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/medicaid/claims/components/MedicalPlanBadges.vue"
export default component.exports